import { loadRestrictedPrincipalsForTemplateForm, saveRestrictedPrincipalsForTemplateForm } from '../proforma-fetchers';
export class LiveFormSecurityApi {
  constructor(cloudId, projectId) {
    this.cloudId = cloudId;
    this.projectId = projectId;
    this.cloudId = cloudId;
    this.projectId = projectId;
  }
  load(projectFormId) {
    return loadRestrictedPrincipalsForTemplateForm(this.cloudId, this.projectId, projectFormId);
  }
  save(projectFormId, principals) {
    return saveRestrictedPrincipalsForTemplateForm(this.cloudId, this.projectId, projectFormId, principals);
  }
}